<div class="registro-container">
  <!-- Brand panel -->
  <div class="registro-brand-panel">
    <div class="brand-content animate-fade-in">
      <div class="brand-logo">
        <img src="/assets/img/identidade-visual/Logo.png" alt="Easy Consultório" />
      </div>

      <div class="brand-benefits">
        <div class="benefit-item">
          <span class="benefit-icon">
            <span class="material-icons">calendar_month</span>
          </span>
          <div class="benefit-text">
            <strong>Agenda inteligente</strong>
            <span>Organize seus atendimentos com facilidade</span>
          </div>
        </div>
        <div class="benefit-item">
          <span class="benefit-icon benefit-icon--cyan">
            <span class="material-icons">description</span>
          </span>
          <div class="benefit-text">
            <strong>Prontuário digital</strong>
            <span>Evolução, anamnese e documentos seguros</span>
          </div>
        </div>
        <div class="benefit-item">
          <span class="benefit-icon benefit-icon--sky">
            <span class="material-icons">payments</span>
          </span>
          <div class="benefit-text">
            <strong>Controle financeiro</strong>
            <span>Receitas, despesas e relatórios completos</span>
          </div>
        </div>
        <div class="benefit-item">
          <span class="benefit-icon benefit-icon--lavender">
            <span class="material-icons">chat</span>
          </span>
          <div class="benefit-text">
            <strong>Lembretes por WhatsApp</strong>
            <span>Reduza faltas com avisos automáticos</span>
          </div>
        </div>
      </div>

      <p class="brand-trial-note">
        <span class="material-icons">verified</span>
        15 dias grátis &middot; Sem cartão de crédito
      </p>
    </div>

    <!-- Decoração angular inspirada no logo -->
    <div class="brand-decoration">
      <div class="swoosh swoosh-1"></div>
      <div class="swoosh swoosh-2"></div>
      <div class="swoosh swoosh-3"></div>
    </div>
  </div>

  <!-- Form panel -->
  <div class="registro-form-panel">
    <!-- Step 1: Registration form -->
    <div class="registro-card animate-slide-up" *ngIf="step === 'form'">
      <div class="registro-header">
        <h2>Crie sua conta</h2>
        <p>Comece seu teste gratuito de 15 dias</p>
      </div>

      <form [formGroup]="registroForm" (ngSubmit)="registrar()" class="registro-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome completo</mat-label>
          <mat-icon matPrefix>person_outline</mat-icon>
          <input matInput formControlName="nome" placeholder="Seu nome completo" />
          <mat-error *ngIf="registroForm.get('nome')?.hasError('required')">Nome é obrigatório</mat-error>
          <mat-error *ngIf="registroForm.get('nome')?.hasError('minlength')">Nome muito curto</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>mail_outline</mat-icon>
          <input matInput type="email" formControlName="email" placeholder="joao&#64;exemplo.com.br" />
          <mat-error *ngIf="registroForm.get('email')?.hasError('required')">Email é obrigatório</mat-error>
          <mat-error *ngIf="registroForm.get('email')?.hasError('email')">Email inválido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Celular (WhatsApp)</mat-label>
          <mat-icon matPrefix>phone_android</mat-icon>
          <input matInput formControlName="celular" mask="(00) 00000-0000" placeholder="(11) 99999-9999" />
          <mat-error *ngIf="registroForm.get('celular')?.hasError('required')">Celular é obrigatório</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>CPF</mat-label>
          <mat-icon matPrefix>badge</mat-icon>
          <input matInput formControlName="cpf" mask="000.000.000-00" placeholder="000.000.000-00" />
          <mat-error *ngIf="registroForm.get('cpf')?.hasError('required')">CPF é obrigatório</mat-error>
          <mat-error *ngIf="registroForm.get('cpf')?.hasError('minlength') || registroForm.get('cpf')?.hasError('cpfInvalido')">CPF inválido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Senha</mat-label>
          <mat-icon matPrefix>lock_outline</mat-icon>
          <input matInput [type]="esconderSenha ? 'password' : 'text'" formControlName="senha" placeholder="Mínimo 6 caracteres" />
          <button mat-icon-button matSuffix type="button" (click)="esconderSenha = !esconderSenha" tabindex="-1">
            <mat-icon>{{esconderSenha ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="registroForm.get('senha')?.hasError('required')">Senha é obrigatória</mat-error>
          <mat-error *ngIf="registroForm.get('senha')?.hasError('minlength')">Mínimo 6 caracteres</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirmar senha</mat-label>
          <mat-icon matPrefix>lock_outline</mat-icon>
          <input matInput [type]="esconderConfirmar ? 'password' : 'text'" formControlName="confirmarSenha" placeholder="Confirme sua senha" />
          <button mat-icon-button matSuffix type="button" (click)="esconderConfirmar = !esconderConfirmar" tabindex="-1">
            <mat-icon>{{esconderConfirmar ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="registroForm.get('confirmarSenha')?.hasError('required')">Confirmação é obrigatória</mat-error>
        </mat-form-field>

        <button mat-flat-button color="primary" type="submit" class="registro-btn" [disabled]="loading">
          <span *ngIf="!loading">Criar conta grátis</span>
          <span *ngIf="loading" class="btn-loading">
            <mat-icon class="spin">autorenew</mat-icon>
            Criando...
          </span>
        </button>
      </form>

      <div class="registro-footer">
        <span>Já tem uma conta? </span>
        <a routerLink="/login">Faça login</a>
      </div>
    </div>

    <!-- Step 2: Email verification -->
    <div class="registro-card animate-slide-up" *ngIf="step === 'verification'">
      <div class="registro-header">
        <div class="verification-icon">
          <span class="material-icons">mark_email_read</span>
        </div>
        <h2>Verifique seu email</h2>
        <p>Enviamos um código de 6 dígitos para <strong>{{emailRegistrado}}</strong></p>
      </div>

      <form [formGroup]="codigoForm" (ngSubmit)="validarEmail()" class="registro-form">
        <mat-form-field appearance="outline" class="full-width codigo-field">
          <mat-label>Código de verificação</mat-label>
          <input matInput formControlName="codigo" mask="000000" placeholder="000000"
            class="codigo-input" maxlength="6" autocomplete="one-time-code" />
          <mat-error *ngIf="codigoForm.get('codigo')?.hasError('required')">Código é obrigatório</mat-error>
          <mat-error *ngIf="codigoForm.get('codigo')?.hasError('minlength')">O código deve ter 6 dígitos</mat-error>
        </mat-form-field>

        <button mat-flat-button color="primary" type="submit" class="registro-btn" [disabled]="loading">
          <span *ngIf="!loading">Verificar email</span>
          <span *ngIf="loading" class="btn-loading">
            <mat-icon class="spin">autorenew</mat-icon>
            Verificando...
          </span>
        </button>
      </form>

      <div class="reenviar-section">
        <p *ngIf="reenviarTimer > 0" class="reenviar-timer">
          Reenviar código em <strong>{{reenviarTimer}}s</strong>
        </p>
        <button *ngIf="reenviarTimer <= 0" mat-button color="primary" (click)="reenviarCodigo()" [disabled]="loading" class="reenviar-btn">
          Reenviar código
        </button>
      </div>

      <div class="registro-footer">
        <button mat-button (click)="voltarParaFormulario()" class="voltar-btn">
          <mat-icon>arrow_back</mat-icon>
          Voltar ao cadastro
        </button>
      </div>
    </div>
  </div>
</div>
